import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';

/**
 * Ruta PÚBLICA (sin auth, fuera de _backoffice): la documentación se comparte por link con terceros.
 * Bajo demanda: el Markdown y react-markdown viajan en su propio chunk, no en el bundle del backoffice.
 */
const DocsPage = lazy(() =>
    import('@/domains/docs/pages/DocsPage').then((m) => ({ default: m.DocsPage })),
);

export const Route = createFileRoute('/docs/$docId/$sectionId')({
    component: DocsRoute,
});

function DocsRoute() {
    const { docId, sectionId } = Route.useParams();
    return (
        <Suspense fallback={<Loading fullScreen text="Cargando documentación…" />}>
            <DocsPage docId={docId} sectionId={sectionId} />
        </Suspense>
    );
}
